<template>
    <div class="content-container">
        <div class="content">
            <div class="container">
                <div class="row">

                    <!-- Options -->
                    <div class="col-12">
                        <div class="title">
                            <h1>Extras</h1>
                        </div>
                    </div>

                    <div class="col-12">
                        <!-- Options -->
                        <div class="col-12" v-for="(option, problemCode) in upsellOptions" :key="problemCode">

                            <div class="card" v-if="problemCode === 'battery-replacement'">
                                <div class="card-header pb-0">
                                    <h4>New battery</h4>
                                    <div class="text-right">
                                        <strong class="text-danger">Now <span v-html="currencySymbol" v-if="countryCodeSetting !== 'DE'"></span>{{ option.now_price }} <span v-html="currencySymbol" v-if="countryCodeSetting === 'DE'"></span></strong>
                                        <br />
                                        <span class="text-sm">
                                            Was <span v-html="currencySymbol" v-if="countryCodeSetting !== 'DE'"></span>{{ option.original_price }} <span v-html="currencySymbol" v-if="countryCodeSetting === 'DE'"></span>
                                        </span>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <ul class="list-sm pl-3">
                                        <li>Battery not lasting as long as it did when device was new?</li>
                                        <li>Draining far too quickly?</li>
                                        <li>We'll fit a brand new one at the same time as your repair!</li>
                                    </ul>
                                    <button class="btn btn-secondary btn-rounded btn-add-to-basket" v-if="!hasProblem(option)" @click="toggleProblem(batteryProblem)">Add to basket</button>
                                    <button class="btn btn-outline-danger btn-rounded btn-add-to-basket btn-check" v-if="hasProblem(option) === true" @click="toggleProblem(batteryProblem)">Remove from basket</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Footer -->
            <footer class="footer fixed-footer">
                <div class="container">
                    <router-link :to="{ name: 'repairSelect'}" class="btn btn-outline-secondary back-btn btn-lg"><i class="fa fa-chevron-left text-sm mr-3"></i> Back</router-link>
                    <button @click="confirmSelections()" class="btn btn-lg continue-btn icon-right ml-auto">Next <i class="fa fa-chevron-right ml-3 text-sm"></i></button>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "Extras",

        mounted() {
            this.checkCanBeOnPage();
        },

        computed: {
            ...mapGetters([
                'askBackGlass',
                'askFrame',
                'backGlassProblem',
                'batteryProblem',
                'frameProblem',
                'hasProblem',
                'selectedProblems',
                'upsellOptions',
                'currencySymbol',
                'countryCodeSetting'
            ]),

            nextStep() {
                if (this.askBackGlass && this.backGlassProblem) return 'confirmDamage';
                if (this.askFrame && this.frameProblem) return 'confirmDamage';

                return 'basket';
            }
        },

        methods: {
            ...mapActions(['checkBookingIsComplete', 'toggleProblem', 'updateDevice']),

            checkCanBeOnPage() {
                this.checkBookingIsComplete().then(() => {
                    if (!this.selectedProblems.length) {
                        this.$router.push({name: 'repairSelect'});
                    }

                    if (!Object.keys(this.upsellOptions).length) {
                        this.$router.push({name: this.nextStep});
                    }
                });
            },

            confirmSelections() {
                this.updateDevice(true);

                this.$router.push({name: this.nextStep});
            }
        }
    }
</script>

<style scoped>

</style>